import * as React from "react";
function LocationUnknownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 14c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm0-7.385A3.388 3.388 0 008.615 10 3.388 3.388 0 0012 13.385 3.388 3.388 0 0015.385 10 3.388 3.388 0 0012 6.615z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.18a.308.308 0 01-.308-.309v-.615c0-.17.138-.308.308-.308a.847.847 0 000-1.692.847.847 0 00-.846.846.308.308 0 01-.615 0c0-.806.655-1.461 1.461-1.461a1.463 1.463 0 01.308 2.89v.34c0 .17-.138.308-.308.308zM12 12.717a.462.462 0 100-.923.462.462 0 000 .923z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.101c-.02 2.535-.902 4.6-2.883 5.94-1.525 1.03-2.522 2.366-3.346 3.931-.233.441-.374 1.047-1.057 1.028-.632-.02-.738-.61-.994-1.018-.257-.408-.51-.868-.746-1.31a6 6 0 00-2.07-2.232c-2.52-1.646-3.665-4.015-3.354-6.989.453-4.321 4.539-7.162 8.584-6.295 3.095.662 4.992 2.624 5.72 5.705.077.41.125.824.146 1.24zm-7.254 10.13c.415-.727.771-1.323 1.103-1.939.575-1.059 1.389-1.873 2.396-2.543 2.14-1.425 3.17-3.45 2.939-6.034-.238-2.667-1.662-4.539-4.123-5.497-2.462-.959-4.803-.498-6.735 1.324-3.101 2.912-2.688 7.743.838 10.14a7.896 7.896 0 012.657 2.912c.267.516.572 1.015.925 1.638z"
  }));
}
const ForwardRef = React.forwardRef(LocationUnknownIcon);
export default ForwardRef;